export const state = {
  accruals: [],
  payments: []
};

export const getters = {
  getPayments: state => state.payments,
  getAccruals: state => state.accruals
};

export default {
  state,
  getters
};
